import React from 'react';
import { Col } from 'antd';

const Headding = () => <Col span={24} className="headding" />;

export default Headding;
